<template>
  <div class="container-fluid p-0">
    <PageTitle
      :title="$t('coralSol.dafor')"
      :titleAdd="$t('dafor.addDafor')"
      :isAdd="true"
      :hasExportCSV="true"
      @onExportCSV="exportCSV"
      />

    <!-- table -->
    <div class="row">
      <div class="col-12 d-flex">
        <div class="card flex-fill">
          <div class="card-body box-dashboard p-0">
            <CoralsolDaforTable @orderBy="orderBy" @search="search" :items="items"/>
          </div>
        </div>
      </div>
    </div>
    <!-- /table -->
  </div>
</template>

<script>
import axios from 'axios'
import PageTitle from '@/components/shared/PageTitle'
import CoralsolDaforTable from './CoralsolDaforTable.vue'

export default {
  name: 'CoralsolDafor',
  components: { CoralsolDaforTable, PageTitle },
  data () {
    return {
      items: [],
      dataOrderBy: {}
    }
  },
  methods: {
    async exportCSV () {
      this.$store.dispatch('showPreload')

      const params = {
        ...this.$store.state.formSearch,
        Page: this.$store.state.currentPage,
        PageSize: 9999
      }

      try {
        const response = await axios.get('/CoralsolDafor/getlistforexport', { params })
        const data = response.data.items

        if (!data || !data.length) {
          this.$toasted.global.defaultError({ msg: 'Nenhum dado encontrado para exportação.' })
          return
        }

        const headers = [
          'ID',
          'Data',
          'Observador',
          'Localidade',
          'Colaborador',
          'Visibilidade Horizontal',
          'Profundidade Mínima',
          'Profundidade Máxima',
          'Método',
          'Zona Batimétrica',
          'Número de Mergulhadores',
          'Número de Transectos Visuais',
          'Transectos Visuais (valores)',
          'Observação',
          'Coordenadas DAFOR'
        ].join(';')

        const rows = data.map(item => {
          return [
            item.dafor_id || '',
            item.date || '',
            item.observer || '',
            item.locality_name || '',
            item.surname || '',
            item.horizontal_visibility || '',
            item.min_depth || '',
            item.max_depth || '',
            item.method || '',
            item.bathymetric_zone || '',
            item.number_of_divers || '',
            item.number_of_visual_transects || '',
            item.dafor_value || '',
            item.observation || '',
            item.dafor_coords || ''
          ].map(value =>
            typeof value === 'string'
              ? `"${value.replace(/"/g, '""')}"`
              : value != null ? value : ''
          ).join(';')
        })

        const csv = `${headers}\n${rows.join('\n')}`

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', 'formulario_dafor_export.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        this.$toasted.global.defaultSuccess({ msg: 'Exportação realizada com sucesso!' })
      } catch (error) {
        this.$toasted.global.defaultError({ msg: 'Erro ao exportar os dados.' })
        console.error('Erro exportCSV DAFOR:', error)
      } finally {
        this.$store.dispatch('hidePreload')
      }
    },
    clear () {
      this.$store.commit('clearFormSearch')
    },
    orderBy (dataOrderBy) {
      this.$store.state.dataOrderBy = dataOrderBy
      this.search()
    },
    setFormOrderBy () {
      this.$store.state.formSearch.OrderByIDAcs = this.$store.state.dataOrderBy.OrderByIDAcs
      this.$store.state.formSearch.OrderByIDDesc = this.$store.state.dataOrderBy.OrderByIDDesc
      this.$store.state.formSearch.OrderByDateAcs = this.$store.state.dataOrderBy.OrderByDateAcs
      this.$store.state.formSearch.OrderByDateDesc = this.$store.state.dataOrderBy.OrderByDateDesc
      this.$store.state.formSearch.LocalityIDAcs = this.$store.state.dataOrderBy.LocalityIDAcs
      this.$store.state.formSearch.LocalityIDDesc = this.$store.state.dataOrderBy.LocalityIDDesc
      this.$store.state.formSearch.NumberofvisualtransectsIDAcs = this.$store.state.dataOrderBy.NumberofvisualtransectsIDAcs
      this.$store.state.formSearch.NumberofvisualtransectsIDDesc = this.$store.state.dataOrderBy.NumberofvisualtransectsIDDesc
    },
    async search () {
      this.$store.dispatch('showPreload')

      this.setFormOrderBy()
      const params = this.$store.state.formSearch
      params.Page = this.$store.state.currentPage
      params.PageSize = this.$store.state.perPage
      await axios.get('/CoralsolDafor/getallgrid', { params })
        .then(response => {
          this.$store.state.currentPage = response.data.page
          this.$store.state.countList = response.data.count
          this.items = response.data.items
        })
    }
  },
  async created () {
    this.$store.state.formSearch.pending_analysis = true
    await this.search()
  }
}
</script>
